import React from 'react';
import Modal from '@omilia/modal';
import { Form, Field } from 'react-final-form';
import Button, { ButtonGroup } from '@omilia/button';
import styled from 'styled-components';

import TextFieldFinalFormWrapper from 'components/TextFieldFinalFormWrapper';
import { Props } from './types';
import validate from './utils/validate';

const SForm = styled.form`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const CreateNewDictionaryModal = ({
  onSubmit,
  onClose,
  onCheckDictionaryName,
}: Props) => (
  <Modal
    open
    shouldCloseOnBackdropClick
    shouldCloseOnEscPress
    glyph="dictionaries"
    title="Create Dictionary"
    onClose={onClose}
  >
    <Form onSubmit={onSubmit}>
      {({ handleSubmit, invalid, submitting }) => (
        <SForm data-test="create-dictionary-modal" onSubmit={handleSubmit}>
          <Field
            component={TextFieldFinalFormWrapper}
            data-test="dictionary-name"
            label="DICTIONARY NAME"
            name="dictionaryName"
            placeholder="Please type a name for the dictionary"
            validate={value => validate(value, onCheckDictionaryName)}
          />
          <ButtonGroup>
            <Button
              color="secondary"
              data-test="cancel"
              variant="text"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              data-test="create-dictionary"
              disabled={invalid}
              loading={submitting}
              type="submit"
              variant="contained"
            >
              Create
            </Button>
          </ButtonGroup>
        </SForm>
      )}
    </Form>
  </Modal>
);

export default CreateNewDictionaryModal;
